import OpdRemainText from './OpdRemainText'

export default OpdRemainText
